// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__130zr","text":"SelectPayment_text__fh-P_","title":"SelectPayment_title__1deZi","btn":"SelectPayment_btn__17mds"};